import { onMounted, onBeforeUnmount, ref, computed } from 'vue'
export const useOrientation = () => {   
    
    const orientation = ref('portrait' as 'landscape' | 'portrait' )
    const setOrientation = () => {
        orientation.value = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
    }
    
    onMounted(() => {
        window.addEventListener('resize', setOrientation);
        setOrientation()
    })
    
    onBeforeUnmount(() => {
        window.removeEventListener('resize', setOrientation)
    })
    
    return {
        isLandscape: computed(() => orientation.value === 'landscape'),
        isPortrait: computed(() => orientation.value === 'portrait'),
        orientation
    }
}